define('models/customer_manager',['require','backbone','models/phone_number'],function(require){

    var Backbone = require('backbone');

    var PhoneNumberModel = require('models/phone_number');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'customer-managers/' + this.id + '/' ) :
                ( App.Config.apiBase + 'customer-managers/' );
        },

        defaults: function () {
            return {
              first_name: "",
              last_name: "",
              email: "",
              phone_number: new PhoneNumberModel().attributes,
              phone_country: 0,
              phone_value: "",
              allow_gdpr: true,
              allow_reminder_mail: true
            };
        }
    });
});
